import styles from "./Input.module.css"
import {parsingInt} from "component/const/Functions";

export const TextInput = ({type, toChange, onChange, value, className, disabled = false}) => {
    return (
        <input
            disabled={disabled}
            type="text"
            placeholder="입력하세요."
            // className={"n"}
            className={`${className? "":styles.input} inputBorder inputTextAreaMargi`}
            value={value[toChange]}
            onChange={(e) => onChange(type !=="number"? e.target.value
                :parsingInt(e.target.type), toChange)}
        />
    );
}